import React from 'react';
import { Helmet } from 'react-helmet';
import avatarCoverStringBuilder from '../helpers/avatarCoverStringBuilder';
import capitalize from '../helpers/capitalize';
const SEO = props => {
  const {
    businessData
  } = props.data.data;
  const {
    pageContext
  } = props.data.pageContext;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, `${businessData.name} | ${capitalize(pageContext.title)}`), /*#__PURE__*/React.createElement("html", {
    lang: "en"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: businessData.desc
  }), /*#__PURE__*/React.createElement("meta", {
    name: "image",
    content: avatarCoverStringBuilder(businessData.avatar.imageBaseUrl, businessData.avatar.imagePrefix)
  }), /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: businessData.links.website
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: businessData.links.website
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: capitalize(pageContext.title)
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: businessData.desc
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: avatarCoverStringBuilder(businessData.avatar.imageBaseUrl, businessData.avatar.imagePrefix)
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:creator",
    content: businessData.links.twitter
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:title",
    content: capitalize(pageContext.title)
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:description",
    content: businessData.desc
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:image",
    content: avatarCoverStringBuilder(businessData.avatar.imageBaseUrl, businessData.avatar.imagePrefix)
  }));
};
export default SEO;